import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wConsts from "../consts/website-consts";
import * as wActs from "../actions/website-actions";
import NotFound from "../components/notfound";
import {Link} from "react-router-dom";

class Home extends Component {

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "home" });

  }
  getSignup() {
    return wActs.getCultPath(this.props.WebPage, "/signup");
  }
  render() {

    if(this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }
    return (
      <div className="main">

        <div className="top-block">
          <div className="container">
            <div className="top-block__content">
              <div className="top-block__h1 blue">
                {wActs.getTranslation(this.props.WebPage.Translations,"page.safetyforsexworkersineurope")}
              </div>
              <div className="top-block__descr">
                <div className="top-block__h2">
                  {wActs.getTranslation(this.props.WebPage.Translations,"page.receivewarningaboutpotentialdangers")}
                </div>
                <div className="top-block__h3">
                  {wActs.getTranslation(this.props.WebPage.Translations,"page.bepartofacaringandsupportivecommunityofsexworkers")}
                </div>
                <Link to={this.getSignup()} className="btn btn--blue btn--lg">
                  {wActs.getTranslation(this.props.WebPage.Translations,"page.joinsitenameforfree").replace("{{SeoName}}",this.props.WebPage.Settings.SeoName)}
                </Link>
              </div>
            </div>

            <div className="store">
              <a href={"https://apps.apple.com/app/smuglist/id1512229795"} target={"_blank"}>
                <img src="/imgs/icons/appstore.png" alt=""/>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.siteways.smuglist" target={"_blank"}>
                <img src="/imgs/icons/googlePlay.png" alt=""/>
              </a>
            </div>
          </div>
        </div>

        <div className="features">
          <div className="container">
            <ul className="features__list flex flex--wrap">
              <li>
                <div className="feature__item">
                  <div className="ico">
                    <i className="fa fa-shield-alt"></i>
                  </div>
                  <div className="h3">{wActs.getTranslation(this.props.WebPage.Translations,"page.firstclassprotection")}</div>
                </div>
              </li>

              <li>
                <div className="feature__item">
                  <div className="ico">
                    <i className="fa fa-user-friends"></i>
                  </div>
                  <div className="h3">{wActs.getTranslation(this.props.WebPage.Translations,"page.supportivecommunity")}</div>
                </div>
              </li>

              <li>
                <div className="feature__item">
                  <div className="ico">
                    <i className="fa fa-flag"></i>
                  </div>
                  <div className="h3">{wActs.getTranslation(this.props.WebPage.Translations,"page.warningsandalerts")}</div>
                </div>
              </li>

              <li>
                <div className="feature__item">
                  <div className="ico">
                    <i className="fa fa-network-wired"></i>
                  </div>
                  <div className="h3">{wActs.getTranslation(this.props.WebPage.Translations,"page.informationsharing")}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="about">
          <div className="container flex flex--wrap">
            <div className="about__img">
              <img src="/imgs/photo-lg.jpg" alt="" />
            </div>
            <div className="about__descr">
              <div className="title">
                <div className="h2">
                  {wActs.getTranslation(this.props.WebPage.Translations,"page.meta.readallaboutseoname").replace("{{SeoName}}",this.props.WebPage.Settings.SeoName)}
                </div>
              </div>

              <p>
                {wActs.getTranslation(this.props.WebPage.Translations,"page.smuglist.home.about").replace("{{SeoName}}",this.props.WebPage.Settings.SeoName)}
              </p>
              <Link to={this.getSignup()} className="btn btn--blue">{wActs.getTranslation(this.props.WebPage.Translations,"page.header.signup")}</Link>
            </div>
          </div>
        </div>

        <div className="description">
          <div className="container">
            <div className="h1">
              {this.props.WebPage.Page.H1Text}
            </div>
            {typeof window !== "undefined" &&
            <p dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.H1TextBlock}}></p>
            }
            <Link to={this.getSignup()} className="btn btn--blue">{wActs.getTranslation(this.props.WebPage.Translations,"page.header.signup")}</Link>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    SelectedLocal: state.Website.Settings.SelectedLocal,
    ProfilePath: state.Website.ProfilePath,
    WebPage: state.Website
  };
};

export default connect(mapStateToProps)(Home);
